module.exports = __webpack_public_path__ + "static/img/level-card-banner2.044eea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/level-card-banner2.png
// module id = pcHp
// module chunks = 1